import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'p-panaya-logo',
    templateUrl: './panaya-logo.component.html',
    styleUrls: ['./panaya-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanayaLogoComponent {}
